export const mainMemberFields = [
  {
    name: "main_identification_number",
    label: "ID Number",
    type: "number",
    validation: { length: 13 },
  },
  { name: "main_surname", label: "Surname", type: "text" },
  { name: "main_full_names", label: "Full Names", type: "text" },
  { name: "main_initials", label: "Initials", type: "text" },
  {
    name: "main_title",
    label: "Title",
    type: "select-text",
    options: ["Mr", "Ms", "Mrs", "Adv", "Dr", "Prof", "Sir"],
  },
  {
    name: "main_gender",
    label: "Gender",
    type: "radio",
    options: ["Male", "Female"],
    readOnly: true,
  },
  {
    name: "main_date_of_birth",
    label: "Date of Birth",
    type: "text",
    readOnly: true,
  },
  { name: "main_employer", label: "Employer", type: "text" },
  { name: "main_cell_number", label: "Cell Number", type: "phone" },
  { name: "main_home_number", label: "Home Number", type: "phone" },
  { name: "main_work_number", label: "Work Number", type: "phone" },
  { name: "main_fax_number", label: "Fax Number", type: "phone" },
  { name: "main_email_address", label: "Email address", type: "email" },
  {
    name: "main_email_statements",
    label: "Email Statements?",
    type: "checkbox",
    description: "Yes",
  },
  { name: "main_physical_address_1", label: "Physical Address", type: "text" },
  { name: "main_physical_address_2", label: "", type: "text" },
  { name: "main_physical_address_3", label: "", type: "text" },
  { name: "main_physical_address_code", label: "Postal Code", type: "number" },
  { name: "main_postal_address_1", label: "Postal Address", type: "text" },
  { name: "main_postal_address_2", label: "", type: "text" },
  { name: "main_postal_address_3", label: "", type: "text" },
  { name: "main_postal_address_code", label: "Postal Code", type: "number" },
];

export const mainMedicalFields = [
  {
    name: "main_medical_scheme",
    label: "Medical Scheme",
    type: "select-text",
    options: [
      "Aeci Medical Aid Society",
      "Alliance - Midmed Medical Scheme",
      "Anglo Medical Scheme",
      "Anglovaal GROUP Medical Scheme",
      "Bankmed",
      "Barloworld Medical Scheme",
      "Bestmed Medical Scheme",
      "Bmw Employees Medical Aid Society",
      "Bonitas Medical Fund",
      "Bp Medical Aid Society",
      "Building & Construction Industry Medical Aid Fund",
      "Cape Medical PLAN",
      "Chartered Accountants(Sa) Medical Aid Fund(Camaf)",
      "Compcare Medical Scheme",
      "Consumer Goods Medical Scheme",
      "De Beers Benefit Society",
      "Discovery Health Medical Scheme",
      "Engen Medical Benefit Fund",
      "Fedhealth Medical Scheme",
      "Fishing Industry Medical Scheme(Fishmed)",
      "Foodmed Medical Scheme",
      "Genesis Medical Scheme",
      "Glencore Medical Scheme",
      "Golden Arrow Employees Medical Benefit Fund",
      "Government Employees Medical Scheme(Gems)",
      "Health Squared Medical Scheme",
      "Horizon Medical Scheme",
      "Impala Medical PLAN",
      "Imperial AND Motus Medical Aid",
      "Keyhealth",
      "La - Health Medical Scheme",
      "Libcare Medical Scheme",
      "Lonmin Medical Scheme",
      "Makoti Medical Scheme",
      "Malcor Medical Scheme",
      "Massmart Health PLAN",
      "Mbmed Medical Aid Fund",
      "Medihelp",
      "Medimed Medical Scheme",
      "Medipos Medical Scheme",
      "Medshield Medical Scheme",
      "Momentum Medical Scheme",
      "Motohealth Care",
      "Multichoice Medical Aid Scheme",
      "Netcare Medical Scheme",
      "Old Mutual Staff Medical Aid Fund",
      "Parmed Medical Aid Scheme",
      "Pg GROUP Medical Scheme",
      "Pick N Pay Medical Scheme",
      "Platinum Health",
      "Profmed",
      "Rand Water Medical Scheme",
      "Remedi Medical Aid Scheme",
      "Retail Medical Scheme",
      "Rhodes University Medical Scheme",
      "Sabc Medical Aid Scheme",
      "Samwumed",
      "Sasolmed",
      "Sedmed",
      "Sisonke Health Medical Scheme",
      "Sizwe Hosmed Medical Scheme",
      "South African Breweries Medical Aid Scheme(Sabmas)",
      "South African Police Service Medical Scheme(Polmed)",
      "Suremed Health",
      "Tfg Medical Aid Scheme",
      "Thebemed",
      "Transmed Medical Fund",
      "Tsogo Sun GROUP Medical Scheme",
      "Umvuzo Health Medical Scheme",
      "University OF Kwa - Zulu Natal Medical Scheme",
      "Witbank Coalfields Medical Aid Scheme",
      "Wooltru Healthcare Fund",
    ],
  },
  {
    name: "main_medical_scheme_plan",
    label: "Medical Scheme Plan",
    type: "text",
  },
  {
    name: "main_medical_gap_cover",
    label: "Gap Cover?",
    type: "checkbox",
    description: "Yes",
  },
  {
    name: "main_medical_member_number",
    label: "Member Number",
    type: "number",
  },
  {
    name: "main_medical_member_main_dep_code",
    label: "Main Member Dependant Code",
    type: "number",
  },
];

export const patientFields = [
  {
    name: "patient_identification_number",
    label: "ID Number",
    type: "number",
    validation: { length: 13 },
  },
  { name: "patient_surname", label: "Surname", type: "text" },
  { name: "patient_full_names", label: "Full Names", type: "text" },
  { name: "patient_nick_names", label: "Nick Name", type: "text" },
  { name: "patient_initials", label: "Initials", type: "text" },
  {
    name: "patient_title",
    label: "Title",
    type: "select-text",
    options: ["Mr", "Ms", "Mrs", "Adv", "Dr", "Prof", "Sir"],
  },
  {
    name: "patient_gender",
    label: "Gender",
    type: "radio",
    options: ["Male", "Female"],
    readOnly: true,
  },
  {
    name: "patient_date_of_birth",
    label: "Date of Birth",
    type: "text",
    readOnly: true,
  },
  { name: "patient_cell_number", label: "Cell Number", type: "phone" },
  {
    name: "patient_use_appoint_test_results",
    label: "Use this number for appointments / test results",
    type: "checkbox",
    description: "Yes",
  },
  { name: "patient_home_number", label: "Home Number", type: "phone" },
  { name: "patient_work_number", label: "Work Number", type: "phone" },
  { name: "patient_email_address", label: "Email Address", type: "email" },
  { name: "patient_occupation", label: "Occupation", type: "text" },
  {
    name: "patient_marital_status",
    label: "Marital Status",
    type: "select-text",
    options: ["Single", "Married", "Widowed", "Divorced", "Separated"],
  },
  {
    name: "patient_relationship_main",
    label: "Relationship to main member",
    type: "text",
  },
  { name: "patient_dep_code", label: "Patient Dependant Code", type: "number" },
  { name: "patient_age", label: "Age", type: "number", readOnly: true },
  { name: "patient_height", label: "Height", type: "height" },
  { name: "patient_weight", label: "Weight", type: "weight" },
  { name: "patient_referring_doctor", label: "Referring Doctor", type: "text" },
  {
    name: "patient_referring_doctor_nuiber",
    label: "Referring Doctor Number",
    type: "number",
  },
  { name: "patient_gp", label: "GP", type: "text" },
  { name: "patient_gp_number", label: "GP Number", type: "phone" },
];

export const patientFields_followup = [
  {
    name: "patient_identification_number",
    label: "ID Number",
    type: "number",
    validation: { length: 13 },
  },
  { name: "patient_surname", label: "Surname", type: "text" },
  { name: "patient_full_names", label: "Full Names", type: "text" },
];

export const nextOfKinFields = [
  { name: "next_kin_initials", label: "Initials", type: "text" },
  {
    name: "next_kin_title",
    label: "Title",
    type: "select-text",
    options: ["Mr", "Ms", "Mrs", "Adv", "Dr", "Prof", "Sir"],
  },
  { name: "next_kin_surname", label: "Surname", type: "text" },
  { name: "next_kin_full_names", label: "Full Names", type: "text" },
  { name: "next_kin_cell_number", label: "Cell Number", type: "phone" },
  {
    name: "next_kin_relationship",
    label: "Relationship to Patient",
    type: "text",
  },
];

export const mandatoryFields = [
  "main_identification_number",
  "main_surname",
  "main_full_names",
  "main_date_of_birth",
  "main_cell_number",
  "main_postal_address_1",
  "main_postal_address_code",
  "main_medical_scheme",
  "main_medical_scheme_plan",
  "main_medical_member_number",
  "patient_identification_number",
  "patient_surname",
  "patient_full_names",
  "patient_date_of_birth",
  "patient_cell_number",
];

export const mandatoryFields_followup = [
  "patient_identification_number",
  "patient_surname",
  "patient_full_names",
];

export const anaestheticFields = Array.from({ length: 26 }, (_, i) => {
  const num = String(i + 1).padStart(2, "0");
  const bitName = `anea_bit_${num}`;
  const detailName = `anea_detail_${num}`;
  const labels = [
    "Previous anaesthetics (when, which operation)",
    "Problems with previous anaesthetics (details)",
    "Any family member with anaesthetic problems (what?)",
    "Porphyria, malignant hyperthermia or scolline apnoea",
    "Allergy / unusual reaction to medicines (which?)",
    "Names of all medication, pills, herbal medicine",
    "Cortisone treatment in the past 12 months",
    "High blood pressure",
    "Heart diseases (eg. Chest pain, heart attack, rheumatic fever)",
    "Previous thrombosis / embolism (legs/lungs?)",
    "What exercise do you do?",
    "Asthma, bronchitis or emphysema",
    "Recent cold, cough or flu",
    "Heavy snoring / problems sleeping",
    "Diabetes or thyroid problems",
    "Jaundice or hepatitis (If so, when?)",
    "Kidney or bladder disease",
    "Muscle weakness or stroke",
    "Tendency to bleed or bruise",
    "Epileptic convulsions or blackout of any sort",
    "Are you pregnant/breastfeeding?",
    "False, loose or crowned teeth (if so, where?)",
    "Alcohol consumption per week",
    "Do you smoke or use an E-cigarette? (if so, how many per day?)",
    "Do you get heartburn / reflux",
    "Is there anything else your anaesthetist should know?",
  ];

  return {
    name: bitName,
    label: labels[i],
    type: "radio",
    options: ["Yes", "No"],
    detailField: {
      name: detailName,
      label: "Details",
      type: "text",
    },
  };
});

